import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52911340"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "faq-item__header" }
const _hoisted_2 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  id: "mdi-plus",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  id: "mdi-minus",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M19,13H5V11H19V13Z" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "faq-item__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_slide_up_down = _resolveComponent("slide-up-down")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
    class: _normalizeClass(['faq-item', _ctx.isOpen && 'faq-item--active'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        (!_ctx.isOpen)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
          : (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(['faq-item__title', _ctx.isOpen && 'faq-item__title--active'])
      }, [
        _renderSlot(_ctx.$slots, "title", {}, undefined, true)
      ], 2)
    ]),
    _createVNode(_component_slide_up_down, {
      "model-value": _ctx.isOpen,
      duration: 300
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_8, [
          _renderSlot(_ctx.$slots, "content", {}, undefined, true)
        ])
      ]),
      _: 3
    }, 8, ["model-value"])
  ], 2))
}